import CalendarIconSvg from 'assets/images/icons/calendar.svg?react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PropertyBusinessType } from 'models/Properties';
import { StackedCalendarMode } from 'pages/stackedCalendar/Calendar.types';
import { calendarModeLocalStorageKey } from 'pages/stackedCalendar/Calendar.constants';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { HeaderContainer } from '../common/header/CommonHeader.styles';
import AddUnitTypeButton from '../common/header/AddUnitTypeButton';
import HeaderIconButton from '../common/header/HeaderIconButton';
import GuidebookHeaderButton from '../common/header/GuidebookHeaderButton';

const PropertySettingsPricingTabHeader = () => {
  const { t } = useTranslation();
  const { uid: propertyUid } = useParams();
  const { property } = usePropertySettingsInitData();

  if (property?.businessType === PropertyBusinessType.HOTEL) {
    return (
      <HeaderContainer>
        <AddUnitTypeButton />
      </HeaderContainer>
    );
  }

  const redirectToCalendarPricing = () => {
    localStorage.setItem(
      calendarModeLocalStorageKey,
      StackedCalendarMode.PRICING,
    );
  };

  return (
    <HeaderContainer>
      <HeaderIconButton
        id="calendar-link"
        text={t('pageProperty.mainSettings.header.calendar')}
        href={`/calendar?propertyUid=${propertyUid}`}
        onClick={redirectToCalendarPricing}
        icon={<CalendarIconSvg />}
      />

      <GuidebookHeaderButton propertyUid={propertyUid} />
    </HeaderContainer>
  );
};

export default PropertySettingsPricingTabHeader;
